"use client";

import config from "@/config/config.json";
import { ThemeProvider } from "next-themes";
import React, {ReactNode, Suspense} from "react";
import AuthProvider from "@/partials/AuthProvider";
import Amplitude from "@/components/Amplitude";
import { Analytics } from "@vercel/analytics/react"

const Providers = ({ children }: { children: ReactNode }) => {
  const { default_theme } = config.settings;

  return (
    <ThemeProvider
      attribute="class"
      defaultTheme={default_theme}
      enableColorScheme={false}
    >
      <AuthProvider>
        <Amplitude />
        {children}
      </AuthProvider>
      <Suspense fallback={null}>
        <Analytics />
      </Suspense>
    </ThemeProvider>
  );
};

export default Providers;
